

// ============================================================
// FILE 3: src/services/trailBuddyApi.js
// Service API per tutte le chiamate trail-buddy
// ============================================================

const API = process.env.REACT_APP_API_URL_NODE || 'http://localhost:3002';
async function request(path, options = {}) {
    const res = await fetch(`${API}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers,
        },
    });

    const data = await res.json();

    if (!res.ok) {
        const err = new Error(data.error || 'Errore API');
        err.status = res.status;
        err.code = data.code;
        err.data = data;
        throw err;
    }

    return data;
}

function authHeaders(token) {
    return token ? { Authorization: `Bearer ${token}` } : {};
}

// ── CRUD Eventi ──

export async function createTrailBuddy(token, eventData) {
    return request('/api/trail-buddy', {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(eventData),
    });
}

export async function listTrailBuddies(token, params = {}) {
    const query = new URLSearchParams(params).toString();
    return request(`/api/trail-buddy?${query}`, {
        headers: authHeaders(token),
    });
}

export async function getTrailBuddy(token, eventId) {
    return request(`/api/trail-buddy/${eventId}`, {
        headers: authHeaders(token),
    });
}

export async function updateTrailBuddy(token, eventId, data) {
    return request(`/api/trail-buddy/${eventId}`, {
        method: 'PATCH',
        headers: authHeaders(token),
        body: JSON.stringify(data),
    });
}

export async function deleteTrailBuddy(token, eventId, hard = false) {
    return request(`/api/trail-buddy/${eventId}${hard ? '?hard=true' : ''}`, {
        method: 'DELETE',
        headers: authHeaders(token),
    });
}

// ── Join / Partecipazione ──

export async function requestJoin(token, eventId) {
    return request(`/api/trail-buddy/${eventId}/join`, {
        method: 'POST',
        headers: authHeaders(token),
    });
}

export async function withdrawJoin(token, eventId) {
    return request(`/api/trail-buddy/${eventId}/join`, {
        method: 'DELETE',
        headers: authHeaders(token),
    });
}

export async function resolveParticipant(token, eventId, participantUid, action) {
    return request(`/api/trail-buddy/${eventId}/participants/${participantUid}`, {
        method: 'PATCH',
        headers: authHeaders(token),
        body: JSON.stringify({ action }),
    });
}

// ── Chat ──

export async function getChat(token, eventId, after = null) {
    const query = after ? `?after=${encodeURIComponent(after)}` : '';
    return request(`/api/trail-buddy/${eventId}/chat${query}`, {
        headers: authHeaders(token),
    });
}

export async function sendMessage(token, eventId, text) {
    return request(`/api/trail-buddy/${eventId}/chat`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify({ text }),
    });
}
